import _ from 'lodash';
import { connect } from 'react-redux';
import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import { Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
/** import mui components in the section above, keep the ascending order */

import { GroupedMultiSelectTabs, MultiSelect } from 'widgets-v6/select';
/** import widgets-v5 and widgets-v6 components in the section above, keep the ascending order */

import { DEAL_CATEGORY_SELECT_TABS, DealCategory, DealStatus } from 'common/constants/deals';
import { WarningText } from 'forms/ad-form/modules/cross-platform-setup-warning';
import actions from 'forms/media-plan-form/actions';
import BaseColumnForm from '../base-column-form';
import flags from 'containers/flags/service';
import selector, { formSelector } from './selector';
import { showDealNotTargetableWarning } from 'states/resources/ads/business-logic';
import shallowCompare from 'utils/shallow-compare';
/** import classes and others in the section above, keep the ascending order */

class DealsSummaryComponent extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate =
            !shallowCompare(this.props, nextProps) || !shallowCompare(this.state, nextState);
        return shouldUpdate;
    }

    render() {
        const { dealsInAd, ad } = this.props;
        const filteredDeals = dealsInAd.filter(deal => {
            if (flags.isEnabled('efb_35_curated_deals')) {
                return true;
            } else {
                return deal.category === DealCategory.Private;
            }
        });
        let dealsNotTargetable = [];

        filteredDeals.map(deal => {
            if (showDealNotTargetableWarning(deal, ad)) {
                dealsNotTargetable.push(deal.app_name);
            }
        });
        return (
            <div>
                <Typography>
                    {_.map(filteredDeals, deal => (
                        <div>{_.get(deal, 'app_name')}</div>
                    ))}
                </Typography>
                {dealsNotTargetable.length > 0 && (
                    <WarningText
                        message={`One or more assigned deals is not targetable throughout the ad’s entire flight. Please check the deal’s start/end date: 
                            • ${dealsNotTargetable.join('\n• ')}`}
                        severity="hard"
                    />
                )}
            </div>
        );
    }
}
export const DealsSummary = connect(selector)(DealsSummaryComponent);

const DealsFormComponent = props => {
    const { ad, ads, campaign, onSave, dealsByOrganization, dispatch } = props;

    const filteredDeals = dealsByOrganization.filter(deal => {
        if (flags.isEnabled('efb_35_curated_deals')) {
            return true;
        } else {
            return deal.category === DealCategory.Private;
        }
    }); // Hide curated deals if flag is disabled

    const options = _.map(filteredDeals, deal => {
        const isExpired = deal.status === DealStatus.Expired;

        return {
            label: isExpired ? `${deal.app_name} (Expired)` : deal.app_name,
            value: deal.id,
            category: deal.category,
            disabled: isExpired,
        };
    });

    const onSaveDeals = async () => {
        if (ads && ads.length > 0) {
            await Promise.all(
                _.map(ads, async ad => {
                    dispatch(actions.fetchAdDeals(ad.id));
                })
            );
        } else {
            await dispatch(actions.fetchAdDeals(ad.id));
        }
        onSave();
    };

    return (
        <BaseColumnForm
            ad={ad}
            ads={ads}
            campaign={campaign}
            headline={flags.isEnabled('efb_35_curated_deals') ? 'Deals' : 'Private Deals'}
            fields={['deals']}
            shouldRefreshPredictionsOnSave={true}
            onSave={onSaveDeals}
            onCancel={onSave}
            columnName={flags.isEnabled('efb_35_curated_deals') ? 'Deals' : 'Private Deals'}
        >
            {(updateDraft, shouldShowErrors, errors, draft) => {
                const draftDealsWithData = draft.deals.map(deal =>
                    dealsByOrganization.find(d => d.id === deal)
                );
                let dealsNotTargetable = [];

                if (ad) {
                    draftDealsWithData.map(deal => {
                        if (showDealNotTargetableWarning(deal, ad)) {
                            dealsNotTargetable.push(deal.app_name);
                        }
                    });
                }

                return (
                    <FormControl fullWidth margin="normal">
                        <FormLabel>
                            {flags.isEnabled('efb_35_curated_deals') ? 'Deals' : 'Private Deals'}
                        </FormLabel>
                        {flags.isEnabled('efb_35_curated_deals') ? (
                            <GroupedMultiSelectTabs
                                value={draft.deals}
                                onChange={value => updateDraft({ deals: value })}
                                options={options}
                                placeholder={
                                    flags.isEnabled('efb_35_curated_deals')
                                        ? 'Select deals'
                                        : 'Select private deals'
                                }
                                tabs={
                                    flags.isEnabled('efb_35_curated_deals')
                                        ? DEAL_CATEGORY_SELECT_TABS
                                        : []
                                }
                                defaultTab={DealCategory.Private}
                                tabField="category"
                            />
                        ) : (
                            <MultiSelect
                                value={draft.deals}
                                onChange={value => updateDraft({ deals: value })}
                                options={options}
                                placeholder={
                                    flags.isEnabled('efb_35_curated_deals')
                                        ? 'Select deals'
                                        : 'Select private deals'
                                }
                            />
                        )}
                        {dealsNotTargetable.length > 0 && (
                            <WarningText
                                message={`One or more assigned deals is not targetable throughout the ad’s entire flight. Please check the deal’s start/end date: 
                                    • ${dealsNotTargetable.join('\n• ')}`}
                                severity="hard"
                            />
                        )}
                    </FormControl>
                );
            }}
        </BaseColumnForm>
    );
};

export const DealsForm = connect(formSelector)(DealsFormComponent);
